import axios from 'axios';
import { CONFIG } from '@/config';

export class BrandingService {
  /**
   * Busca as configurações de branding da API.
   */
  static async getBranding() {
    try {
      const response = await axios.get(`${CONFIG.API_URL}/branding`);
      return response.data.data;
    } catch (error) {
      console.error('Erro ao buscar branding:', error);
      return null;
    }
  }

  /**
   * Injeta as variáveis de branding no DOM.
   */
  static applyBranding(branding: any) {
    if (!branding) return;

    const root = document.documentElement;

    // Cores Principais do Ionic
    if (branding.cor_principal) {
      this.setIonicColor(root, 'primary', branding.cor_principal);
    }

    // Cor do Login
    if (branding.cor_login) {
      root.style.setProperty('--color-login', branding.cor_login);
      root.style.setProperty('--color-login-bg', branding.cor_background_login || branding.cor_login);
    }

    // Favicon e Título
    if (branding.favicon) {
      this.updateFavicon(branding.favicon);
    }

    if (branding.nome_sistema) {
      document.title = branding.nome_sistema;
    }

    // Armazena logos e favicon no localStorage para fácil acesso e evitar flicker
    if (branding.logo_login) {
      localStorage.setItem('logo_login', branding.logo_login);
      localStorage.setItem('branding_logo_login', branding.logo_login);
    } else {
      localStorage.removeItem('logo_login');
      localStorage.removeItem('branding_logo_login');
    }

    if (branding.logo_sistema) {
      localStorage.setItem('logo_sistema', branding.logo_sistema);
      localStorage.setItem('branding_logo_sistema', branding.logo_sistema);
    } else {
      localStorage.removeItem('logo_sistema');
      localStorage.removeItem('branding_logo_sistema');
    }

    if (branding.favicon) {
      localStorage.setItem('branding_favicon', branding.favicon);
    } else {
      localStorage.removeItem('branding_favicon');
    }
  }

  private static updateFavicon(url: string) {
    let link: any = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = url;
  }

  private static hexToRgb(hex: string): string {
    const bigint = parseInt(hex.replace('#', ''), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return `${r}, ${g}, ${b}`;
  }

  private static setIonicColor(root: HTMLElement, name: string, hex: string) {
    root.style.setProperty(`--ion-color-${name}`, hex);
    root.style.setProperty(`--ion-color-${name}-rgb`, this.hexToRgb(hex));
    
    // Shade and Tint (Approximation)
    root.style.setProperty(`--ion-color-${name}-shade`, hex); 
    root.style.setProperty(`--ion-color-${name}-tint`, hex);
  }
}
